module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAVtJREFUKFOFkj1Lw1AUhs9Jik5CwdHBSXARJ2eTCA4xtckiTk4Oji7+AOcujg46OCrS0jQktCKCP6F+IBYV/Eb9ASbNva9Em9JPvOO957nPe869bJrm5GhGKQhSNl3XfaUhy7btLEmxI0Db7OStAyJeA+FWItRd96QPTACWokZMcwQcs+M44ySap8Q8S8ANh02jWK2+pcJugBpNCZ2Tw14wjKXu+/67bWtZlmN/BsIdR0IrBsHzL9QLgugaJFYVqPutSPeSI61crj0ltW2oz9i6DKCHWELzPO8xFXRByWY+b84opNbTAgEx77r+eedQ/zUR6IrU0CiVah99ps5hAGhIkusKKXvMPEWEy+9IGEEQfLZ76gViSbrneS+WZU1kFDpLQAAXAmxUKpWvrndKDCmQRukECajH4AW2l5cOmZWVQcAgEJBHnMstTqs8UoglbSSRhv29lnFXINr6ATJ71kAGAc+FAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/img/close.png
// module id = ZnwD
// module chunks = 43